import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "../components/Modal";
import { Button, Select } from 'styled'
import axios from "apis/axios";
import toast from "react-hot-toast";
import { tyrePositionsOptions } from "../utils/helpers"
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];


const OnWheelStencils = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [data, setData] = useState([])
  const [selectedPositions, setSelectedPositions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [contractType, setContractType] = useState("")
  const [stdDevRange, setStdDevRange] = useState([0, 30]);
  const [showSlider, setShowSlider] = useState(true);
  const [downloadingFiltered, setDownloadingFiltered] = useState(false);

  const getData = async () => {
    setIsLoading(true)
    const dt = await getAllData("/report/onwheelstencils", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
            .map((item) => item.value)
            .join(","),
        }
        : selectedFleets.length && {
          fleets: selectedFleets.map((fleet) => fleet).join(","),
        }),


      ...(!selectedPositions?.includes("all") &&
        selectedPositions?.length && {
        positions: selectedPositions.map((kam) => kam).join(","),
      }),
      ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {}),
      ...contractType !== "" && {
        contractType
      },
    })
    //console.log(dt)
    setData(dt);
    setIsLoading(false)
  }

  const getDownloadData = async () => {
    setDownloading(true)
    const dt = await getAllData("/report/onwheelstencils", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
            .map((item) => item.value)
            .join(","),
        }
        : selectedFleets.length && {
          fleets: selectedFleets.map((fleet) => fleet).join(","),
        }),

      ...(!selectedPositions?.includes("all") &&
        selectedPositions.length && {
        positions: selectedPositions.map((kam) => kam).join(","),
      }),
      ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {}),
      ...contractType !== "" && {
        contractType
      },
    })
    //console.log(dt)

    if (dt) {
      setData(dt);
      let exportData = dt?.data?.map((x, idx) => ({
        "S.N": idx + 1,
        "Mobility Fleet": `${x?.fleet} (${x?.fleetCity})`,
        "On Wheel": x?.tyres ?? 0,
        "Less than 4 NSD": x?.lessThan4 ?? 0,
        "Between 4 and 8 NSD": x?.between4And8 ?? 0,
        "Over 8 NSD": x?.greaterThan8 ?? 0,
      }))

      exportData.push({
        "Mobility Fleet": "TOTAL",
        "On Wheel": dt.totalRow?.tyreCount ?? 0,
        "Less than 4 NSD": dt.totalRow?.lessThan4Count,
        "Between 4 and 8 NSD": dt.totalRow?.between4And8Count ?? 0,
        "Over 8 NSD": dt.totalRow?.greaterThan8Count ?? 0,
      })

      exportExcel(exportData, "onWheelStencils", true)
    }

    // exportExcel(
    //   dt?.data?.map((x, idx) => ({
    //     "S.N": idx + 1,
    //     "Mobility Fleet": x?.fleet,
    //     "On Wheel": x?.tyres?.length,
    //     "Less than 4 NSD": x?.lessThan4?.length,
    //     "Between 4 and 8 NSD": x?.between4And8?.length,
    //     "Over 8 NSD": x?.greaterThan8?.length,
    //   })),
    //   "onWheelStencils.xlsx"
    // );
    setDownloading(false)
  }
  
  const getDownloadTyreData=()=>{
    const myPromise = axios({
      method: 'post',
      data: {
        ...(selectedFleets?.includes("all")
          ? {
            fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
          : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),

        ...(!selectedPositions?.includes("all") &&
          selectedPositions.length && {
          positions: selectedPositions.map((kam) => kam).join(","),
        }),
        ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {}),
        ...contractType !== "" && {
          contractType
        },
        reportName: "On Wheel Stencil Details",
      },
      url: "report/fleetStockDetails/download",
    });

    toast.promise(myPromise, {
      loading: 'Request Initiated, Please Hold on',
      success: (dt) => {
        return dt.data.message;
      },
      error: (err) =>{
        return err?.response?.data.error ||
        err?.response?.data.message ||
        err?.message ||
        'Something went wrong'},
    },
    {
      success: {
        duration: 3000,
        icon: '📩',
      },
    });
  }


  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getPositionOptions = () => {
    return [
      {
        label: "All",
        value: "all",
      },
      {
        label: "Clear",
        value: "clear"
      },
      ...tyrePositionsOptions.map(item => ({
        label: item,
        value: item
      }))
    ]
  }

  return (
    <div>
      <div className="w-full px-8 flex justify-center items-end gap-4">
        <label className="w-full py-3 flex flex-col gap-2">
          Select Fleets
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes("clear")) {
                // console.log(allValues)
                setSelectedFleets([]);
                return;
              }
              if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter(item => item.value !== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              // console.log({allHubs, selectedHubs})

              setSelectedFleets(value.map((fleet) => fleet.value));
            }
            }
            name="fleets"
            isMulti={true}
          />
        </label>

        <label className="w-full py-3 flex flex-col gap-2">
          Select Positions
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getPositionOptions()}
            value={
              selectedPositions &&
              selectedPositions
                .filter((position) => position !== "all" && position !== "clear").map((position) => {
                  return {
                    value: position,
                    label: getPositionOptions()?.find((item) => item?.value === position)
                      ?.label,
                  };
                })
            }
            onChange={(value) => {
              console.log('value--', value, selectedPositions);
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes("clear")) {
                setSelectedPositions([]);
                return;
              }
              if (allValues?.includes("clear")) {
                setSelectedPositions([]);
              } else if (allValues?.includes("all")) {
                const allPositions = getPositionOptions()
                  .filter((item) => item.value !== "all" && item.value !== "clear")
                  .map((item) => item.value);
                setSelectedPositions(allPositions);
              } else {
                setSelectedPositions(allValues);
              }
            }}
            name="positions"
            isMulti={true}
          />
        </label>

      </div>
      <div className="w-full px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 justify-start items-end">
        <label className="w-full py-3 flex flex-col gap-2">
          Contract Type
          <ReactSelect
            styles={filterSelectStyles}
            name="contractType"
            className="shadow-md rounded-md"
            value={contractTypeOptions.find(option => option.value === contractType)} // Find the option object based on the value
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />
        </label>
        <label className="w-full py-3 col-span-1 lg:col-span-2 flex flex-col gap-2">
          Standard Deviation
          <div className=" bg-white pr-3 shadow-md rounded-md border w-full">
            <div className="flex items-center">
              <div className="flex flex-col">

                <div
                  className="w-[100px] bg-gray-100 inline-flex justify-center items-center py-2 border rounded-md cursor-pointer"
                // onClick={() => setShowSlider(!showSlider)}
                >
                  {stdDevRange[0]} - {stdDevRange[1]}
                </div>
              </div>

              {showSlider && (
                <div className="custom-slider ml-6 w-full pr-[1rem]">
                  <Slider
                    range
                    min={0}
                    max={30}
                    step={0.1}
                    value={stdDevRange}
                    onChange={(val) => setStdDevRange(val)}
                  />
                </div>
              )}
            </div>
          </div>
        </label>

        <div className="flex flex-row flex-wrap gap-2 text-center justify-center items-end mb-3">
          <Button type="button" disabled={(!selectedFleets.length)} bgPrimary onClick={() => getData()}>
            Search
          </Button>
          {downloading ? 'Downloading...' : selectedFleets.length !== 0 && <Button
              className="col-span-1 h-10 text-sm text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownloadData()
              }}
            > <BiCloudDownload h={12} w={12} /> Count</Button>}
           {downloadingFiltered ? "Downloading data..." : selectedFleets.length !== 0 && <Button
              className="col-span-1 h-10 text-sm text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownloadTyreData()
              }}
            > <BiCloudDownload h={12} w={12} />   Data</Button>}


        </div>

      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Mobility Fleet</TH>
                      <TH scope="col">On Wheel</TH>
                      <TH scope="col">{"< 4 NSD"}</TH>
                      <TH scope="col">{"4 - 8 NSD"}</TH>
                      <TH scope="col">{"> 8 NSD"}</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data?.data?.length ?
                      data?.data?.map((d, idx) => (
                        <ViewList data={d} idx={idx} selectedFleets={selectedFleets} contractType={contractType} selectedPositions={selectedPositions} stdDevRange={stdDevRange} />
                      ))
                      : <></>}
                  </tbody>
                  {data?.totalRow ? <tfoot>
                    <tr className="text-gray-600 font-semibold bg-green-100">
                      <TD></TD>
                      <TD className="text-left">
                        TOTAL
                      </TD>
                      <TD colSpan={1} className="text-left">
                        {data?.totalRow?.tyreCount}
                      </TD>
                      <TD >
                        {data?.totalRow?.lessThan4Count}
                      </TD>
                      <TD >
                        {data?.totalRow?.between4And8Count}
                      </TD>
                      <TD>
                        {data?.totalRow?.greaterThan8Count}
                      </TD>
                    </tr>
                  </tfoot> : <></>}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnWheelStencils;

const ViewList = ({ data, idx, selectedFleets, contractType, selectedPositions, stdDevRange }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  const [modalQuery, setModalQuery] = useState(null)
  const modalHandler = useCallback(
    (data) => {
      if (data) {
        setModalData(data);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData([]);
      }
    },
    [showModal, modalData]
  );

  const getModalData = async (modalQueryProp) => {
    // console.log("Modal Q", modalQueryProp)
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      // console.log("making modal call")
      const dt = await getAllData("/report/onwheelstencils/modalInfo", {
        hubs: modalQueryProp.hubs,
        status: modalQueryProp.status,
        minNSD: modalQueryProp.minNSD,
        maxNSD: modalQueryProp.maxNSD,
        fleets: modalQueryProp.fleetId,
        contractType,
        ...(!selectedPositions?.includes("all") &&
          selectedPositions?.length && {
          positions: selectedPositions.map((kam) => kam).join(","),
        }),
        ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {})
      });
      // console.log(dt)
      setModalData(dt)
    }
    setIsLoading(false);
  }

  const getDownload = async (minNSD, maxNSD, fleetId) => {
    const myPromise = axios({
      method: 'post',
      data: {
        ...(fleetId && {
          fleets: fleetId,
        }),
        ...contractType !== "" && {
          contractType
        },
        status: "FITTED",
        ...minNSD && { minNSD },
        ...maxNSD && { maxNSD },
        reportName: "On Wheel Stencil Details",
        ...(!selectedPositions?.includes("all") &&
          selectedPositions?.length && {
          positions: selectedPositions.map((kam) => kam).join(","),
        }),
        ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {}),

      },
      url: `report/fleetStockDetails/download`,
    });

    toast.promise(myPromise, {
      loading: 'Request Initiated, Please Hold on',
      success: (dt) => {
        //console.log(dt)
        return dt.data.message;
      },
      error: (err) => {
        //console.log({err});
        return err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          'Something went wrong'
      },
    },
      {
        success: {
          duration: 3000,
          icon: '📩',
        },
      });
  }
  return (
    <Fragment>
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{data?.fleet} ({data.fleetCity})</TD>
        <TD>
          <div className="">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() => {
                let props = { data: data?.tyres, minNSD: null, maxNSD: null, fleetId: data?.fleetId }
                setModalQuery(props)
                getModalData(props)
              }
              }
            >
              {data?.tyres ?? 0}
            </span>
            {/* <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownload(null, null, data?.fleetId)

              }}
            /> */}
          </div>
        </TD>
        <TD>
          <div className="">
            <span
              className="hover:text-green-500 cursor-pointer text-red-500 font-semibold"
              onClick={() => {
                let props = { data: data?.tyres, minNSD: 0, maxNSD: 3.9999, fleetId: data?.fleetId }
                setModalQuery(props)
                getModalData(props)
              }}
            >
              {data?.lessThan4 || 0}
            </span>
            {/* <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownload(0, 3.99999, data?.fleetId)
              }}
            /> */}
          </div>
        </TD>
        <TD>
          <div className="">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() => {
                let props = { data: data?.tyres, minNSD: 4, maxNSD: 8, fleetId: data?.fleetId }
                setModalQuery(props)
                getModalData(props)
              }}
            >
              {data?.between4And8 || 0}
            </span>
            {/* <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownload(4, 8, data?.fleetId)

              }}
            /> */}
          </div>
        </TD>
        <TD>
          <div className=" text-green-600 font-semibold">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() => {
                let props = { data: data?.tyres, minNSD: 8.01, maxNSD: null, fleetId: data?.fleetId }
                setModalQuery(props)
                getModalData(props)
              }}
            >
              {data?.greaterThan8 || 0}
            </span>
            {/* <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownload(8.01, null, data?.fleetId)

              }}
            /> */}
          </div>
        </TD>
      </tr>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={"On wheel tyre details"}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          {isLoading ? <Spinner /> :
            <>
              <h1 className="w-full flex justify-end text-end px-2 my-1">
                <Button
                  onClick={() => {
                    console.log(modalData)
                    getDownload(modalQuery?.minNSD, modalQuery?.maxNSD, modalData?.data[0]?.fleetId)
                  }}
                  className="text-blue-500 hover:scale-105 cursor-pointer text-right"
                >
                  Download
                </Button>
              </h1>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Last Inspection Date</TH>
                    <TH scope="col">Hub</TH>
                    <TH scope="col">Vehicle Number</TH>
                    <TH scope="col">Position</TH>
                    <TH scope="col">Stencil Number</TH>
                    <TH scope="col">Killometer Covered</TH>
                    <TH scope="col">Average NSD</TH>
                    <TH scope="col">Standard Deviation</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {modalData ?
                    modalData?.data.map((d, idx) => {
                      // //console.log(typeof d.vehicle.lastInspectionDate);
                      return (
                        <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
                          <TD>{idx + 1}</TD>
                          <TD>
                            {d?.lastInspectionDate}
                            {/* ? new Date(d?.vehicle?.lastInspectionDate).getDate() + "/" +  new Date(d?.vehicle?.lastInspectionDate).getMonth() + "/" +  new Date(d?.vehicle?.lastInspectionDate).getFullYear()
                           : "" */}
                          </TD>
                          <TD>{d?.hub}</TD>
                          <TD>{d?.vehicle}</TD>
                          <TD>{d?.position}</TD>
                          <TD>{d?.stencilNo}</TD>
                          <TD>{d?.totalKillometerTravelled}</TD>
                          <TD>{Number(d?.averageNSD).toFixed(2)}</TD>
                          <TD>{Number(d?.stdDevNSD).toFixed(2)}</TD>
                          {/* <TD>{allMonths[data?.month]}</TD>
                    <TD>{data?.totalInspections}</TD> */}
                        </tr>
                      );
                    }) : <></>}
                </tbody>
              </table>
            </>}
        </Modal>
      )}
    </Fragment>
  );
};
